import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { ExternalLinkIcon, ArrowUpDownIcon, SearchIcon } from 'lucide-react';
const mockPayersData = [{
  id: '001',
  name: 'Aetna',
  sourceUrl: 'https://www.aetna.com/health-care-professionals/policies-guidelines.html',
  ageInDays: 3,
  lastUpdated: '2023-06-18'
}, {
  id: '039',
  name: 'AlohaCare',
  sourceUrl: 'https://www.alohacare.org/providers/medical-policies/',
  ageInDays: 5,
  lastUpdated: '2023-06-16'
}, {
  id: '027',
  name: 'AmeriHealth Insurance Company',
  sourceUrl: 'https://www.amerihealth.com/providers/medical_policies.html',
  ageInDays: 1,
  lastUpdated: '2023-06-20'
}, {
  id: '004',
  name: 'Arkansas Blue Cross and Blue Shield',
  sourceUrl: 'https://www.arkansasbluecross.com/providers/medical-policies',
  ageInDays: 7,
  lastUpdated: '2023-06-14'
}, {
  id: '040',
  name: 'AvMed',
  sourceUrl: 'https://www.avmed.org/providers/policies',
  ageInDays: 2,
  lastUpdated: '2023-06-19'
}, {
  id: '052',
  name: 'BCBS Wellmark',
  sourceUrl: 'https://www.wellmark.com/Provider/MedPoliciesAndAuthorizations/MedicalPolicies.aspx',
  ageInDays: 4,
  lastUpdated: '2023-06-17'
}, {
  id: '041',
  name: 'Baylor Scott & White Health Plan',
  sourceUrl: 'https://www.bswhealth.com/providers/policies-guidelines',
  ageInDays: 10,
  lastUpdated: '2023-06-11'
}, {
  id: '013',
  name: 'Blue Cross & Blue Shield of Mississippi',
  sourceUrl: 'https://www.bcbsms.com/providers/medical-policy-coverage-guidelines',
  ageInDays: 8,
  lastUpdated: '2023-06-13'
}, {
  id: '029',
  name: 'Blue Cross & Blue Shield of Rhode Island',
  sourceUrl: 'https://www.bcbsri.com/providers/policies',
  ageInDays: 12,
  lastUpdated: '2023-06-09'
}, {
  id: '003',
  name: 'Blue Cross Blue Shield of Arizona',
  sourceUrl: 'https://www.azblue.com/healthcareprofessionals/resource-center/policies',
  ageInDays: 6,
  lastUpdated: '2023-06-15'
}];
const Payers: React.FC = () => {
  const {
    theme
  } = useTheme();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  const filteredData = mockPayersData.filter(payer => payer.id.toLowerCase().includes(searchTerm.toLowerCase()) || payer.name.toLowerCase().includes(searchTerm.toLowerCase()));
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortField) return 0;
    const fieldA = a[sortField as keyof typeof a];
    const fieldB = b[sortField as keyof typeof b];
    if (fieldA < fieldB) return sortDirection === 'asc' ? -1 : 1;
    if (fieldA > fieldB) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
  return <div className={`p-6 min-h-full ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`} data-id="element-317">
      <div className="mb-6" data-id="element-318">
        <h2 className="text-2xl font-extralight tracking-tight mb-2" data-id="element-319">
          Payers Database
        </h2>
        <p className={`${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} font-extralight`} data-id="element-320">
          Manage and monitor all payer sources for the scraper system
        </p>
      </div>
      <div className={`p-4 rounded-lg mb-6 ${theme === 'dark' ? 'bg-gray-800/70 backdrop-blur-sm border border-gray-700/50' : 'bg-white/90 backdrop-blur-sm border border-gray-200'}`} data-id="element-321">
        <div className="flex items-center mb-4" data-id="element-322">
          <div className="relative flex-1" data-id="element-323">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-324">
              <SearchIcon size={16} className={theme === 'dark' ? 'text-gray-400' : 'text-gray-500'} data-id="element-325" />
            </div>
            <input type="text" placeholder="Search by ID or name..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className={`pl-10 pr-4 py-2 w-full rounded-md text-sm ${theme === 'dark' ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-gray-50 border-gray-300 text-gray-900 placeholder-gray-500'} border focus:outline-none focus:ring-2 ${theme === 'dark' ? 'focus:ring-fuchsia-500' : 'focus:ring-fuchsia-300'}`} data-id="element-326" />
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-327">
          <table className="w-full" data-id="element-328">
            <thead className={theme === 'dark' ? 'bg-gray-700/50' : 'bg-gray-100'} data-id="element-329">
              <tr data-id="element-330">
                <th className="px-4 py-2 text-left text-sm font-medium cursor-pointer" onClick={() => handleSort('id')} data-id="element-331">
                  <div className="flex items-center" data-id="element-332">
                    ID
                    <ArrowUpDownIcon size={14} className="ml-1" data-id="element-333" />
                  </div>
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium cursor-pointer" onClick={() => handleSort('name')} data-id="element-334">
                  <div className="flex items-center" data-id="element-335">
                    Payer Name
                    <ArrowUpDownIcon size={14} className="ml-1" data-id="element-336" />
                  </div>
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium" data-id="element-337">
                  Source URL
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium cursor-pointer" onClick={() => handleSort('ageInDays')} data-id="element-338">
                  <div className="flex items-center" data-id="element-339">
                    Age (Days)
                    <ArrowUpDownIcon size={14} className="ml-1" data-id="element-340" />
                  </div>
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium cursor-pointer" onClick={() => handleSort('lastUpdated')} data-id="element-341">
                  <div className="flex items-center" data-id="element-342">
                    Last Updated
                    <ArrowUpDownIcon size={14} className="ml-1" data-id="element-343" />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700/30" data-id="element-344">
              {sortedData.map(payer => <tr key={payer.id} className={`${theme === 'dark' ? 'hover:bg-gray-700/30' : 'hover:bg-gray-50'}`} data-id="element-345">
                  <td className="px-4 py-3 text-sm" data-id="element-346">{payer.id}</td>
                  <td className="px-4 py-3 text-sm" data-id="element-347">{payer.name}</td>
                  <td className="px-4 py-3 text-sm" data-id="element-348">
                    <div className="flex items-center" data-id="element-349">
                      <a href={payer.sourceUrl} target="_blank" rel="noopener noreferrer" className={`truncate max-w-xs ${theme === 'dark' ? 'text-fuchsia-400 hover:text-fuchsia-300' : 'text-fuchsia-600 hover:text-fuchsia-800'}`} data-id="element-350">
                        {payer.sourceUrl}
                      </a>
                      <ExternalLinkIcon size={14} className="ml-1 flex-shrink-0" data-id="element-351" />
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-352">
                    <span className={payer.ageInDays > 7 ? 'text-yellow-500' : 'text-green-500'} data-id="element-353">
                      {payer.ageInDays}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-354">{payer.lastUpdated}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default Payers;